import React, {useEffect, useState, useCallback, useRef, useLayoutEffect} from "react";
import Head from "next/head";
import {connect} from "react-redux";
import {
    initLevel,
    initPlaceHolderLayout,
    setMarkerActivity,
    initScreenSize,
} from "../redux/actions/actions";
import Marker from "./Marker";
import {Pannellum} from "./pannellum-react";
import Client from "./Client";
import SplashScreen from "./SplashScreen";
import ErrorBoundary from "./ErrorBoundary";
import MapWrapPopup from "./MapWrapPopup";
import Media from "./Media";
import IfloorplanSlider from "./Slider/IfloorplanSlider";
import {isStripTouchActive} from "./Slider/IfloorplanSlider";
import UnpublishedNotice from "./unpublishedNotice";
import Popup from "reactjs-popup";
import parse from "html-react-parser";
import {useRouter} from "next/router";
import {createPortal} from "react-dom";
import Draggable from "react-draggable";
import DragAndDrop from "./DragAndDrop";
import LandscapSlider from "./Slider/LandscapSlider";
import {TransformWrapper} from "react-zoom-pan-pinch";
import {getSize, getViewSize, setScreenType, isPortraitMobile, isLandscapeMobile, isTablet, isEmbedded} from "../utils/screenSize";
import {submitFeedback} from '../serverRequests/requests';
import {initGestureTracking, destroyGestureTracking, trackPinchZoomPlan, trackPinchZoomImages, trackPanPlan, trackSwipeImages, trackTapLevelTab, trackTapAgent, trackTapMaps, trackTapReadMore, trackTapShare, trackTapFeedback, trackTapReset, trackTapPlan, trackTapCreatedBy} from '../utils/gestureTracker';


const Start = (props) => {
    const router = useRouter();
    const ifloorplan = props.ifl_state;
    const levels = ifloorplan.level[props.now_level];
    const images = levels.images;
    const pannellums = levels.panelum;

    const [screenSizeRatio] = useState(
        window.innerWidth / (window.innerHeight - 46)
    );
    const [size, setSize] = useState(getSize(screenSizeRatio));
    const [viewSize, setViewSize] = useState(getViewSize(screenSizeRatio));
    const [activeButtonMore, setActiveButtonMore] = useState(false); //button more action enable/disable
    const [activeMarkers, setActiveMarkers] = useState(true); //arrows hide/visible
    const [isMarkerClicked, setIsMarkerClicked] = useState(false); //to check if marker clicked
    const brandingQuery =
        window.location.href.split("?").length > 1
            ? window.location.href.split("?")[1]
            : "";

    const [slidePlay, setSlidePlay] = useState(true);

    const [zoom, setZoom] = useState(false);
    // (stripPinching removed — plan lock handled directly in MobileStrip via DOM)

    const [splashScreen, setSplashScreen] = useState(true);

    const [heightImage, setHeigthImage] = useState(0);

    const [verticalPadding, setVerticalPadding] = useState(Number.MAX_VALUE);

    const [media, setMedia] = useState("");
    const [mediaType, setMediaType] = useState(
        props.ifl_state.level[props.now_level].images.length > 0
            ? "image"
            : "panorama"
    ); // image/video/panorama
    const [indexMarker, setIndexMarker] = useState(null);
    const [openImage, setOpenImage] = useState(false);
    const [markers, setMarkers] = useState([]); //render markers

    const [mapStart, setMapStart] = useState(false); //action map enable/disable

    const [tabsStyle, setTabsStyle] = useState(
        JSON.parse(props.ifl_state.tabs_style)
    );
    const [tabs, setTabs] = useState([]); //render tabs array
    const [mediaTabs, setMediaTabs] = useState([]);

    const [sliderData, setSliderData] = useState([]);

    const [mediaIndex, setMediaIndex] = useState(); // index active media screen
    const [mediaScreen, setMediaScreen] = useState(false); // enable/disable media screen
    const [yaw, setYaw] = useState(0);
    const [hfov, setHfov] = useState(0);
    const [pitch, setPitch] = useState(0);
    const MAX_LIVE_PANOS = 3; // keep-alive 360 viewers (current + recently viewed)
    const [displayMedia, setDisplayMedia] = useState(""); // 360 currently shown
    const [livePanos, setLivePanos] = useState([]); // urls of live 360 viewers
    const [isPortrait, setIsPortrait] = useState(false);
    const [isLandscape, setIsLandscape] = useState(false);
    const [isTabletState, setIsTablet] = useState(false);
    const [sliderTop, setSliderTop] = useState(0);
    const [sliderLeft, setSliderLeft] = useState(0);
    const [showAgentModal, setShowAgentModal] = useState(false);
    const [showBrandModal, setShowBrandModal] = useState(false);
    const [mobileTabs, setMobileTabs] = useState([]);
    const [allPlan, setAllPlan] = useState({});
    const [mobileTextFontSize, setMobileTextFontSize] = useState();
    const [restartAfterSplashScreen, setRestartAfterSplashScreen] =
        useState(false);
    const [copiedUrl, setCopiedUrl] = useState(false);
    const [showShareMenu, setShowShareMenu] = useState(false);
    const planRef = useRef();
    const mobileHeaderRef = useRef(null);
    const tabsContainerRef = useRef(null);
    const tabsMeasureRef = useRef(null);
    const moreTabRef = useRef(null);
    const [visibleTabCount, setVisibleTabCount] = useState(null);
    const [measureTick, setMeasureTick] = useState(0);
    const [moreMenuPos, setMoreMenuPos] = useState(null);
    const [showMoreTabsDropdown, setShowMoreTabsDropdown] = useState(false);
    const [showHint, setShowHint] = useState(false);
    const [kenBurnsZoom, setKenBurnsZoom] = useState({
        from: {
            transform: "scale(1)",
        },
        to: {
            transform: "scale(1.5)",
        },
        config: {
            duration: 8000,
        },
    });

    const [textStyle, setTextStyle] = useState({
        fontWeight: props.ifl_state.addressFontWeight,
        fontStyle: props.ifl_state.addressFontStyle,
        fontSize: (props.ifl_state.addressFontSize * viewSize[1]) / 100 + "px",
        fontFamily: props.ifl_state.addressFontFamily,
        color: props.ifl_state.textColor,
        position: "absolute",
        bottom: props.ifl_state.addressPosition_y + "%",
        left: props.ifl_state.addressPosition_x + "%",
        // transition: "0.5s"
    });
    const [imageWrapStyle, setImageWrapStyle] = useState({
        position: "absolute",
        width: props.ifl_state.img_width + "%",
        height: props.ifl_state.img_height + "%",
        top: props.ifl_state.img_pos_y + "%",
        left: props.ifl_state.img_pos_x + "%",
    });
    const [planWrapStyle, setPlanWrapStyle] = useState({
        position: "absolute",
        width: props.ifl_state.level[props.now_level].plan_width + "%",
        top: props.ifl_state.level[props.now_level].plan_pos_y + "%",
        left: props.ifl_state.level[props.now_level].plan_pos_x + "%",
    });

    const [clientWrapStyle, setClientWrapStyle] = useState({
        position: "absolute",
        top: props.ifl_state.client_block_y + "%",
        left: props.ifl_state.client_block_x + "%",
        transform: "scale(" + props.ifl_state.client_scale + ")",
        transformOrigin: "top left",
        width: (80 * viewSize[1]) / 100 + "px",
        height: (20 * viewSize[1]) / 100 + "px",
    });

    const [showInfoModal, setShowInfoModal] = useState(false);
    const [contentInfoModal, setContentInfoModal] = useState(
        props.ifl_state.textBlock || ""
    );
    const [finishLoadImage, setFinishLoadImage] = useState(false);
    const [finishLoadSplashScreen, setFinishLoadSplashScreen] = useState(false);
    const [finishLoadPlan, setFinishLoadPlan] = useState(false);
    const [startLoading, setStartLoading] = useState(false);
    useEffect(() => {
        if (finishLoadSplashScreen) {
            setStartLoading(true);
        }
    }, [finishLoadSplashScreen]);
    useEffect(() => {
        const timer = setTimeout(() => setStartLoading(true), 3000);
        return () => clearTimeout(timer);
    }, []);
    const loadedImageCount = useRef(0);
    const sliderDataLenRef = useRef(0);
    const stripSwipeRef = useRef(false);
    const preloadImagesRef = useRef([]);
    useEffect(() => {
        sliderDataLenRef.current = sliderData.length;
    }, [sliderData]);
    useEffect(() => {
        if (!sliderData.length) {
            setFinishLoadImage(true);
            return;
        }
        const imgs = [0, 1, 2, 3].filter(i => i < sliderData.length).map((i) => {
            const img = new Image();
            img.src = sliderData[i].data?.img;
            return img;
        });
        preloadImagesRef.current = imgs;
        const decodes = imgs.map(img => img.decode().catch(() => {}));
        Promise.all(decodes).then(() => setFinishLoadImage(true));
    }, [sliderData]);
    const handleSliderImageLoaded = useCallback(() => {
        loadedImageCount.current += 1;
        const target = Math.min(sliderDataLenRef.current, 4);
        if (loadedImageCount.current >= target) {
            setFinishLoadImage(true);
        }
    }, []);
    const [showPublishModal, setShowPublishModal] = useState(false);
    const [showPublishedModal, setshowPublishedModal] = useState(false);
    const [animation, setAnimation] = useState(0);
    const [showShareIcons, setShowShareIcons] = useState(false);
    const [copiedLink, setCopiedLink] = useState(false);
    const transformWrapperRef = useRef(null);
    const [shareUrl] = useState(
        (props.current_user?.domain_api
            ? props.current_user.domain_api
            : window.location.href.replace(router.asPath, "") + "/ifloorplan/") +
        props.ifl_state.id
    );
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const [feedbackUseful, setFeedbackUseful] = useState(null);
    const [feedbackRole, setFeedbackRole] = useState('');
    const [feedbackRating, setFeedbackRating] = useState(0);
    const [feedbackName, setFeedbackName] = useState('');
    const [feedbackEmail, setFeedbackEmail] = useState('');
    const [feedbackMessage, setFeedbackMessage] = useState('');
    const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
    const [feedbackSubmitting, setFeedbackSubmitting] = useState(false);
    const handleSetScreenType = useCallback(() => {
        setScreenType(isPortrait, isLandscape, setSize, setViewSize);
    }, [isPortrait, isLandscape]);
    const stateInit = () => {
        const screenRatio = window.innerWidth / (window.innerHeight - 46);
        const screenWidth =
            screenRatio < 1.7777
                ? (99 * window.innerWidth) / 100
                : (174.22 * window.innerHeight) / 100;
        const screenHeight =
            screenRatio < 1.7777
                ? (55.69 * window.innerWidth) / 100
                : (99 * window.innerHeight) / 100;

        props.initScreenSize({
            width: screenWidth,
            height: screenHeight,
        });

        props.initPlaceHolderLayout({
            width: (ifloorplan.img_width * screenWidth) / 100,
            height: (ifloorplan.img_height * screenHeight) / 100,
        });
    };

    const cropAllPlans = () => {
        let all_plans = {};
        const promises = props.ifl_state.level.map((_, i) => {
            return new Promise((resolve) => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                const pixelRatio = window.devicePixelRatio;
                ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
                ctx.imageSmoothingQuality = "high";
                let plan_image = new Image();
                plan_image.onload = () => {
                    canvas.width =
                        props.ifl_state.level[i].plan_level[0].crop_width *
                        plan_image.naturalWidth;
                    canvas.height =
                        props.ifl_state.level[i].plan_level[0].crop_height *
                        plan_image.naturalHeight;
                    ctx.drawImage(
                        plan_image,
                        props.ifl_state.level[i].plan_level[0].crop_x *
                        plan_image.naturalWidth,
                        props.ifl_state.level[i].plan_level[0].crop_y *
                        plan_image.naturalHeight,
                        props.ifl_state.level[i].plan_level[0].crop_width *
                        plan_image.naturalWidth,
                        props.ifl_state.level[i].plan_level[0].crop_height *
                        plan_image.naturalHeight,
                        0,
                        0,
                        props.ifl_state.level[i].plan_level[0].crop_width *
                        plan_image.naturalWidth,
                        props.ifl_state.level[i].plan_level[0].crop_height *
                        plan_image.naturalHeight
                    );
                    canvas.toBlob((blob) => {
                        all_plans[i] = URL.createObjectURL(blob);
                        resolve();
                    });
                };
                plan_image.crossOrigin = "Anonymous";
                plan_image.src = props.ifl_state.level[i].plan_level[0]?.img;
            });
        });
        Promise.all(promises).then(() => {
            setAllPlan(all_plans);
        });
    };
    useEffect(() => {
        const handleResizeScreen = () => {
            let portrait, landscape;
            if (isEmbedded()) {
                // Inside an iframe the player must lay out from the iframe's own
                // dimensions, not the parent's touch/screen (which would make a
                // desktop embed look like a landscape non-touch device and hide
                // the floor plan). Treat a portrait/landscape-shaped iframe under
                // 1024px wide as a mobile device regardless of pointer type.
                const w = window.innerWidth;
                const h = window.innerHeight;
                portrait = w < h && w <= 1024;
                landscape = w > h && w <= 1024;
            } else {
                portrait = isPortraitMobile();
                landscape = isLandscapeMobile();
            }
            setIsPortrait(portrait);
            setIsLandscape(landscape);
            setScreenType(portrait, landscape, setSize, setViewSize);
            if (!isEmbedded() && (portrait || landscape || isTablet())) {
                setShowHint(true);
            } else {
                setShowHint(false);
            }
        };
        let stabilizeTimer = null;
        let stableSamples = 0;
        let lastW = 0;
        let lastH = 0;
        const stopStabilizing = () => {
            if (stabilizeTimer) {
                clearTimeout(stabilizeTimer);
                stabilizeTimer = null;
            }
        };
        const stabilize = () => {
            stopStabilizing();
            const w = window.innerWidth;
            const h = window.innerHeight;
            if (w === lastW && h === lastH) {
                stableSamples++;
            } else {
                stableSamples = 0;
            }
            lastW = w;
            lastH = h;
            handleResizeScreen();
            if (stableSamples < 2) {
                stabilizeTimer = setTimeout(stabilize, 150);
            }
        };
        const handleOrientationChange = () => {
            stableSamples = 0;
            lastW = 0;
            lastH = 0;
            stabilize();
        };
        const portraitMQ = window.matchMedia("(orientation: portrait)");
        const landscapeMQ = window.matchMedia("(orientation: landscape)");
        const handleMqChange = () => handleOrientationChange();
        portraitMQ?.addEventListener?.("change", handleMqChange);
        landscapeMQ?.addEventListener?.("change", handleMqChange);
        const visualViewport = window.visualViewport;
        visualViewport?.addEventListener?.("resize", handleOrientationChange);
        handleResizeScreen();
        window.addEventListener("resize", handleResizeScreen);
        window.addEventListener("orientationchange", handleOrientationChange);
        document.addEventListener("click", (e) => {
            setShowHint(false);
            if (e.target.className === "media") {
                setMediaScreen(false);
                setMediaIndex("null");
            }
        });
        window.addEventListener("touchstart", (e) => {
            setShowHint(false);
        });
        return () => {
            stopStabilizing();
            destroyGestureTracking();
            portraitMQ?.removeEventListener?.("change", handleMqChange);
            landscapeMQ?.removeEventListener?.("change", handleMqChange);
            visualViewport?.removeEventListener?.("resize", handleOrientationChange);
            window.removeEventListener("resize", handleResizeScreen);
            window.removeEventListener("orientationchange", handleOrientationChange);
        };
    }, []);

    useEffect(() => {
        initMarkers();
    }, [viewSize]);

    useEffect(() => {
        if (finishLoadPlan && props.ifl_state?.id) {
            initGestureTracking(
                props.ifl_state.id,
                () => transformWrapperRef.current?.instance?.state?.scale || 1,
                () => props.now_level
            );
            let lastScale = transformWrapperRef.current?.instance?.state?.scale || 1;
            let lastX = transformWrapperRef.current?.instance?.state?.positionX || 0;
            let lastY = transformWrapperRef.current?.instance?.state?.positionY || 0;
            let gestureActive = false;
            let stableTicks = 0;
            let firedZoom = false;
            let firedPan = false;
            const STABLE_TICKS_BEFORE_END = 4;
            const checkTransform = setInterval(() => {
                const inst = transformWrapperRef.current?.instance?.state;
                if (!inst) return;
                const scaleChanged = Math.abs(inst.scale - lastScale) > 0.1;
                const posChanged = Math.abs(inst.positionX - lastX) > 10 || Math.abs(inst.positionY - lastY) > 10;
                if (scaleChanged || posChanged) {
                    if (!gestureActive) {
                        gestureActive = true;
                        firedZoom = false;
                        firedPan = false;
                    }
                    stableTicks = 0;
                    if (scaleChanged) {
                        if (!firedZoom) {
                            trackPinchZoomPlan();
                            firedZoom = true;
                        }
                        lastScale = inst.scale;
                    }
                    if (posChanged && !scaleChanged) {
                        if (!firedPan) {
                            trackPanPlan();
                            firedPan = true;
                        }
                        lastX = inst.positionX;
                        lastY = inst.positionY;
                    }
                } else if (gestureActive) {
                    stableTicks++;
                    if (stableTicks >= STABLE_TICKS_BEFORE_END) {
                        gestureActive = false;
                    }
                }
            }, 500);
            return () => clearInterval(checkTransform);
        }
    }, [finishLoadPlan, props.ifl_state?.id]);

    useEffect(() => {
        if (isPortrait || isLandscape) {
            setImageWrapStyle({
                ...imageWrapStyle,
                left: isPortrait
                    ? `calc((-96vw + ${viewSize[0]}px) / 2)`
                    : props.ifl_state.img_pos_x + "%",
            });
        }
        setTextStyle({
            ...textStyle,
            fontSize: (props.ifl_state.addressFontSize * viewSize[1]) / 100 + "px",
        });
    }, []);

    useEffect(() => {
        setClientWrapStyle({
            ...clientWrapStyle,
            width: (80 * viewSize[1]) / 100 + "px",
            height: (20 * viewSize[1]) / 100 + "px",
        });

        setTextStyle({
            ...textStyle,
            fontSize: (props.ifl_state.addressFontSize * viewSize[1]) / 100 + "px",
        });
    }, [viewSize]);

    useEffect(() => {
        handleSetScreenType();
        if (isPortrait || isLandscape) {
            setTabsStyle({
                top: "0%",
                left: "0%",
            });
            setClientWrapStyle({...clientWrapStyle, background: props.ifl_state.bgColor});

            const onClickOutsideImage = (e) => {
                setShowHint(false);
                if (
                    e.target.className === "mainWrapIfloorplan" ||
                    e.target.id === "plan" ||
                    e.target.className === "start" ||
                    e.target.className === "screenOverlay"
                ) {
                    if (e.target.className !== "screenOverlay") {
                        setIndexMarker(null);
                    }
                    setOpenImage(false);
                    setIsMarkerClicked(false);
                    setActiveButtonMore(false);
                }
            };
            const onscroll = (e) => {
                const header =
                    document.getElementsByClassName("mobilePlayerHeader")?.[0];
                if (header) {
                    const headerHeight = header.offsetHeight;
                    const scrollY = e.target.scrollTop;
                    if (scrollY > headerHeight) {
                        header.classList.add("sticky");
                    } else {
                        header.classList.remove("sticky");
                    }
                }
            };
            document.addEventListener("click", onClickOutsideImage);
            document.addEventListener("scroll", onscroll);

            // window.addEventListener("orientationchange", () => {
            //     location.reload();
            // });

            props.ifl_state.address && fitText();
            return () => {
                document.removeEventListener("click", onClickOutsideImage);
                document.removeEventListener("scroll", onscroll);
            };
        } else {
            setTabsStyle(JSON.parse(props.ifl_state.tabs_style));
        }
    }, [isPortrait, isLandscape, window]);

    useEffect(() => {
        setPlanWrapStyle({
            ...planWrapStyle,
            width:
                (isPortrait
                    ? props.ifl_state.level[props.now_level].portrait_plan_width
                    : isLandscape
                        ? props.ifl_state.level[props.now_level].landscape_plan_width
                        : props.ifl_state.level[props.now_level].plan_width) + "%",
            top:
                (isPortrait
                    ? props.ifl_state.level[props.now_level].portrait_plan_pos_y
                    : isLandscape
                        ? props.ifl_state.level[props.now_level].landscape_plan_pos_y
                        : props.ifl_state.level[props.now_level].plan_pos_y) + "%",
            left:
                (isPortrait
                    ? props.ifl_state.level[props.now_level].portrait_plan_pos_x
                    : isLandscape
                        ? props.ifl_state.level[props.now_level].landscape_plan_pos_x
                        : props.ifl_state.level[props.now_level].plan_pos_x) + "%",
            position: "absolute",
        });

        setImageWrapStyle({
            ...imageWrapStyle,
            width: props.ifl_state.img_width + "%",
            height: props.ifl_state.img_height + "%",
            top: props.ifl_state.img_pos_y + "%",
            left: isPortrait
                ? `calc((-96vw + ${viewSize[0]}px) / 2)`
                : props.ifl_state.img_pos_x + "%",
        });
    }, [props.now_level, isPortrait, isLandscape]);

    useEffect(() => {
        zoom
            ? setTextStyle({
                ...textStyle,
                left: "15%",
                position: "fixed",
                top: "1%",
            })
            : setTextStyle({
                ...textStyle,
                left: props.ifl_state.addressPosition_x + "%",
                position: "absolute",
                top: props.ifl_state.addressPosition_y + "%",
            });
    }, [zoom]);

    const Publish = () => {
        //publish function
        let newState = JSON.parse(JSON.stringify(props.ifl_state)); //last state ifloorplan
        if (props.type_action === "new" || !newState.first_published_datetime) {
            //if create new plan but not edit
            newState.end_live = parseInt(
                new Date().getTime() / 1000 + 365 * 24 * 3600
            ); //add time delay to delete
        }
        newState.published = true; //set active status publish
        updateNewPlan(newState).then((data) => {
            setAnimation((animation) => animation + 1);
            if (props.type_action === "edit") {
                //if edit - not change step
                return 1;
            }
            //  else {
            //     handleClickItem("");
            // }
        });
    };

    const tabsInit = () => {
        const tabs_ready = [];
        const media_tabs = [];
        const mobile_tabs = [];
        const tab_num = props.ifl_state.level.length + props.ifl_state.media.length;
        props.ifl_state.level.length > 1 &&
        props.ifl_state.level.map((value, index) => {
            if (index == props.now_level) {
                tabs_ready.push(
                    <div className="tab active_tab"
                         key={index}
                         style={{
                             zIndex: tab_num + 1,
                             transform: `translateX(-${10 * index}px)`,
                         }}>
                        {value.tabLabel}
                    </div>
                );
            } else {
                tabs_ready.push(
                    <div className="tab"
                         onClick={() => {
                             trackTapLevelTab();
                             props.initLevel(index);
                             setMediaScreen(false);
                             setMediaIndex("null");
                         }}
                         key={index}
                         style={{
                             zIndex: tab_num - index,
                             transform: `translateX(-${10 * index}px)`,
                         }}>
                        {value.tabLabel}
                    </div>
                );
            }
        });

        if (
            props.ifl_state.level.length === 1 &&
            props.ifl_state.media.length > 0
        ) {
            if (props.now_level == 0) {
                tabs_ready.push(
                    <div className="tab active_tab"
                         onClick={() => {
                             trackTapLevelTab();
                             setMediaScreen(false);
                             setMediaIndex("null");
                         }}
                         key={0}
                         style={{
                             zIndex: tab_num + 1,
                         }}>
                        Floorplan view
                    </div>
                );
            } else {
                tabs_ready.push(
                    <div className="tab"
                         onClick={() => {
                             trackTapLevelTab();
                             props.initLevel(0);
                             setMediaScreen(false);
                             setMediaIndex("null");
                         }}
                         key={0}
                         style={{
                             zIndex: tab_num,
                         }}>
                        Floorplan view
                    </div>
                );
            }
        }

        props.ifl_state.level.length > 1 &&
        props.ifl_state.level.map((value, index) => {
            mobile_tabs.push(
                <div className={index == props.now_level ? "tab active_tab" : "tab"}
                     onClick={() => {
                         trackTapLevelTab();
                         props.initLevel(index);
                         setMediaScreen(false);
                         setMediaIndex("null");
                     }}
                     key={`ml-${index}`}
                     data-tab-index={index}>
                    {value.tabLabel}
                </div>
            );
        });
        if (
            props.ifl_state.level.length === 1 &&
            props.ifl_state.media.length > 0
        ) {
            if (props.now_level == 0) {
                mobile_tabs.push(
                    <div className="tab active_tab"
                         onClick={() => {
                             trackTapLevelTab();
                             setMediaScreen(false);
                             setMediaIndex("null");
                         }}
                         key="ml-floorplan"
                         data-tab-index="floorplan">
                        Floorplan view
                    </div>
                );
            } else {
                mobile_tabs.push(
                    <div className="tab"
                         onClick={() => {
                             trackTapLevelTab();
                             props.initLevel(0);
                             setMediaScreen(false);
                             setMediaIndex("null");
                         }}
                         key="ml-floorplan"
                         data-tab-index="floorplan">
                        Floorplan view
                    </div>
                );
            }
        }

        props.ifl_state.media.map((value, index) => {
            media_tabs.push(
                <div
                    className={mediaIndex == index ? "tab active_tab" : "tab"}
                    onClick={(event) => {
                        trackTapLevelTab();
                        if (event.target.className != "tab active_tab") {
                            setMediaIndex(index);
                            setMediaScreen(true);
                        } else {
                            setMediaScreen(false);
                            setMediaIndex("null");
                        }
                    }}
                    key={index}
                    style={{
                        zIndex:
                            mediaIndex === index
                                ? tab_num + 1
                                : props.ifl_state.media.length - index,
                        transform: `translateX(-${10 * (index + props.ifl_state.level.length)
                        }px)`,
                    }}
                >
                    {value.label}
                </div>
            );
            mobile_tabs.push(
                <div
                    className={mediaIndex == index ? "tab active_tab" : "tab"}
                    onClick={(event) => {
                        trackTapLevelTab();
                        if (event.target.className != "tab active_tab") {
                            setMediaIndex(index);
                            setMediaScreen(true);
                        } else {
                            setMediaScreen(false);
                            setMediaIndex("null");
                        }
                    }}
                    key={`mm-${index}`}
                >
                    {value.label}
                </div>
            );
        });

        setMediaTabs(media_tabs);
        setTabs(tabs_ready);
        setMobileTabs(mobile_tabs);
        setVisibleTabCount(null);
    };

    useEffect(() => {
        const handleWindowClick = (event) => {
            let parentElement = event.target.parentElement;
            if (typeof event.target.className === "object") {
                setActiveButtonMore(prev => prev);
            } else if (!parentElement?.className.includes("moreMenu")) {
                setActiveButtonMore(false);
                setCopiedUrl(false);
            }
            if (showMoreTabsDropdown && !event.target.closest('.mobileMoreTab') && !event.target.closest('.moreTabsDropdown')) {
                setShowMoreTabsDropdown(false);
            }
        };
        window.addEventListener("click", handleWindowClick);
        return () => window.removeEventListener("click", handleWindowClick);
    }, [showMoreTabsDropdown]);

    const buttonMore = (e) => {
        e.preventDefault();
        setActiveButtonMore(prev => !prev);
        setCopiedUrl(false);
        setShowShareMenu(false);
    };

    const initMarkers = () => {
        //init all markers
        const imagesArray = props.ifl_state.level[props.now_level].images;
        const videoArray = props.ifl_state.level[props.now_level].video_marker;
        const panelumArray = props.ifl_state.level[props.now_level].panelum;
        const data = [];
        for (let i = 0; i < imagesArray.length; i++) {
            if (imagesArray[i].cam_pos_x !== 0) {
                data.push({action: "image marker", data: imagesArray[i]});
            }
        }
        for (let i = 0; i < videoArray.length; i++) {
            if (videoArray[i].pos_x !== 0) {
                data.push({action: "video marker", data: videoArray[i]});
            }
        }
        for (let i = 0; i < panelumArray.length; i++) {
            if (panelumArray[i].pos_x !== 0) {
                data.push({action: "panelum marker", data: panelumArray[i]});
            }
        }
        const render = [];
        let minX = Number.MAX_VALUE;
        for (let i = 0; i < data.length; i++) {
            const src = data[i].action == "image marker"
                ? indexMarker == i
                    ? props.ifl_state.marker_image_hover
                    : props.ifl_state.marker_image
                : indexMarker == i
                    ? props.ifl_state.marker360_image_hover
                    : props.ifl_state.marker360_image;
            const markerWidth =
                data[i].action == "image marker"
                    ? props.ifl_state.marker_width
                    : props.ifl_state.marker360_width;
            render.push(
                <Marker
                    key={i}
                    index={i}
                    action={data[i].action}
                    setHeigthImage={setHeigthImage}
                    data={data[i].data}
                    active={indexMarker == i ? true : false}
                    setIndexMarker={setIndexMarker}
                    openImage={openImage}
                    setOpenImage={setOpenImage}
                    setMedia={setMedia}
                    setMediaType={setMediaType}
                    setYaw={setYaw}
                    setPitch={setPitch}
                    setHfov={setHfov}
                    setSlidePlay={setSlidePlay}
                    isPortrait={isPortrait}
                    isLandscape={isLandscape}
                    setSliderTop={setSliderTop}
                    setSliderLeft={setSliderLeft}
                    viewSize={viewSize}
                    setKenBurnsZoom={setKenBurnsZoom}
                    planRef={planRef}
                    setIsMarkerClicked={setIsMarkerClicked}
                    src={src}
                    markerWidth={markerWidth}
                />
            );
            minX = Math.min(minX, data[i].data.cam_pos_y);
        }
        setVerticalPadding(Math.abs(minX));
        setMarkers(render);
    };

    useEffect(() => {
        const imageBlock = document.getElementsByClassName("ifloorPlanSlider")[0];
        imageBlock &&
        imageBlock.getBoundingClientRect().height != 0 &&
        setHeigthImage(imageBlock.getBoundingClientRect().height);
        initMarkers();
    }, [indexMarker, openImage, imgShow]);

    useEffect(() => {
        if (isPortrait) {
            setImageWrapStyle({
                ...imageWrapStyle,
                top: sliderTop + "%",
                left: `calc((-96vw + ${viewSize[0]}px) / 2)`,
                display: 'block',
                // zIndex: !openImage ? 122 : 124,
                // display: !openImage ? "none" : "block",
            });
            props.initPlaceHolderLayout({
                width: (96 * window.innerWidth) / 100,
                height: (45 * window.innerHeight) / 100,
            });
        } else if (isLandscape) {
            setImageWrapStyle({
                ...imageWrapStyle,
                top: "0",
                left:
                    sliderLeft === 50
                        ? `${sliderLeft}%`
                        : `-${(window.innerWidth - viewSize[0]) / 2}px`,
                zIndex: !openImage ? 122 : 124,
                display: !openImage ? "none" : "block",
            });
            props.initPlaceHolderLayout({
                width: (50 * window.innerWidth) / 100,
                height: (90 * window.innerHeight) / 100,
            });
        }
    }, [sliderTop, sliderLeft, isLandscape, isPortrait, openImage]);

    useEffect(() => {
        initMarkers();
        tabsInit(); //init tabs position

        props.ifl_state.level.map((level) => {
            level.images.sort(function (imga, imgb) {
                if (imga.sortIndex < imgb.sortIndex) {
                    return -1;
                }
                if (imga.sortIndex > imgb.sortIndex) {
                    return 1;
                }
                return 0;
            });
        });

        const preparateData = [];
        for (let i = 0; i < props.ifl_state.level.length; i++) {
            for (let j = 0; j < props.ifl_state.level[i].images.length; j++) {
                preparateData.push({
                    data: props.ifl_state.level[i].images[j],
                    l_index: i,
                    m_index: j,
                });
            }
        }
        setSliderData(preparateData);

        const background = document.getElementsByClassName("mainWrapIfloorplan")[0];
        background.style.background = props.ifl_state.bgColor;
        document.body.style.background = props.ifl_state.bgColor;
        // document.getElementsByClassName("start")[0].style.width = width;
        // document.getElementsByClassName("start")[0].style.height = height;
        if (props.ifl_state.level[props.now_level].images.length > 0) {
            setMedia(props.ifl_state.level[props.now_level].images[0]?.img);
        } else if (props.ifl_state.level[props.now_level].panelum.length > 0) {
            setMedia(props.ifl_state.level[props.now_level].panelum[0].img);
            setYaw(props.ifl_state.level[props.now_level].panelum[0].yaw);
            setHfov(props.ifl_state.level[props.now_level].panelum[0].hfov);
            setPitch(props.ifl_state.level[props.now_level].panelum[0].pitch);
        }
        cropAllPlans();
    }, [imgShow]);

    useEffect(() => {
        if (!finishLoadPlan || !finishLoadSplashScreen || !finishLoadImage) return;
        if (!isPortrait && !isLandscape) {
            setIndexMarker(0);
            setOpenImage(true);
        }
        document
            .getElementsByClassName("splash_screen")[0]
            ?.classList.add("fade");
        const hideTimer = setTimeout(() => {
            setSplashScreen(false);
        }, 800);
        return () => clearTimeout(hideTimer);
    }, [finishLoadImage, finishLoadPlan, finishLoadSplashScreen]);

    const recenterPlan = () => {
        if (!transformWrapperRef.current) return;
        const wrapper = document.querySelector(".react-transform-wrapper");
        const content = document.querySelector(".react-transform-component");
        if (!wrapper || !content) return;
        const scale = isTablet() ? 0.64 : 0.8;
        const x = Math.max(0, (wrapper.getBoundingClientRect().width - content.offsetWidth * scale) / 2);
        const y = 30;
        const { positionX, positionY } = transformWrapperRef.current.instance.state;
        if (positionX === x && positionY === y) return;
        transformWrapperRef.current.setTransform(x, y, scale, 300);
    };

    useEffect(() => {
        if (finishLoadPlan && transformWrapperRef.current) {
            recenterPlan();
        }
    }, [finishLoadPlan, isPortrait, isLandscape]);

    useEffect(() => {
        const planDiv = document.querySelector('.plan.my_plan');
        if (!planDiv) return;
        const blockRzpp = (e) => {
            if (isStripTouchActive()) e.stopPropagation();
        };
        planDiv.addEventListener('touchstart', blockRzpp, { capture: true, passive: true });
        return () => planDiv.removeEventListener('touchstart', blockRzpp, { capture: true });
    }, [startLoading]);

    useEffect(() => {
        if (transformWrapperRef.current) {
            setFinishLoadPlan(false); // Reset the load state when level changes
        }
    }, [props.now_level]);

    useEffect(() => {
        if (zoom) {
            setActiveMarkers(false);
        } else {
            setActiveMarkers(true);
        }
    }, [zoom]);

    useEffect(() => {
        tabsInit();
    }, [mediaIndex, props.now_level]);

    useLayoutEffect(() => {
        if (mobileTabs.length === 0) return;
        const container = tabsContainerRef.current;
        const measureEl = tabsMeasureRef.current;
        if (!container || !measureEl) return;

        const tabs = Array.from(measureEl.children);
        const tabsToCount = tabs.slice(0, -1); // last child is the More tab
        const moreTabWidth = tabs.length > 0 ? tabs[tabs.length - 1].offsetWidth : 55;
        const availWidth = container.offsetWidth;

        // Count how many full tabs fit without "More"
        let totalWidth = 0;
        let count = 0;
        for (let i = 0; i < tabsToCount.length; i++) {
            totalWidth += tabsToCount[i].offsetWidth;
            if (totalWidth > availWidth) break;
            count++;
        }

        if (count >= tabsToCount.length) {
            // All tabs fit
            setVisibleTabCount(tabsToCount.length);
            return;
        }

        // Need "More" tab - find how many fit with "More" reserved
        let adjustedCount = 0;
        totalWidth = 0;
        for (let i = 0; i < tabsToCount.length; i++) {
            const w = tabsToCount[i].offsetWidth;
            if (totalWidth + w + moreTabWidth > availWidth) break;
            totalWidth += w;
            adjustedCount++;
        }

        setVisibleTabCount(Math.max(1, adjustedCount));
    }, [mobileTabs, measureTick, splashScreen]);

    useEffect(() => {
        if (mobileTabs.length === 0 || splashScreen) return;
        const reMeasure = () => setMeasureTick((t) => t + 1);
        document.fonts?.ready?.then(reMeasure).catch(() => {});
        window.addEventListener("resize", reMeasure);
        return () => window.removeEventListener("resize", reMeasure);
    }, [mobileTabs, splashScreen]);

    useEffect(() => {
        const fromSwipe = stripSwipeRef.current;
        stripSwipeRef.current = false;
        if (fromSwipe) {
            initMarkers();
            tabsInit();
            return;
        }
        if ((isPortrait || isLandscape) && !openImage) {
            setIndexMarker(-1);
        } else setIndexMarker(0);
        setMediaType(
            props.ifl_state.level[props.now_level].images.length > 0
                ? "image"
                : "panorama"
        );
        if (props.ifl_state.level[props.now_level].images.length > 0) {
            setMedia(props.ifl_state.level[props.now_level].images[0].img);
        } else if (props.ifl_state.level[props.now_level].panelum.length > 0) {
            setMedia(props.ifl_state.level[props.now_level].panelum[0].img);
            setYaw(props.ifl_state.level[props.now_level].panelum[0].yaw);
            setHfov(props.ifl_state.level[props.now_level].panelum[0].hfov);
            setPitch(props.ifl_state.level[props.now_level].panelum[0].pitch);
        }
        initMarkers();
        tabsInit(); //init tabs position
    }, [props.now_image, props.now_level, imgShow]);

    // Keep 360 viewers alive: the shown pano is never torn down, so switching
    // back to a viewed pano is instant (no reload, no loading bar, no grey).
    useEffect(() => {
        if (mediaType !== "panorama" || !media) return;
        if (media !== displayMedia) {
            // Show the requested pano immediately. If it is already alive the
            // view swaps instantly; if it is new it mounts and loads with the
            // preview until ready (same UX as the original single Pannellum).
            setDisplayMedia(media);
        }
        setLivePanos((prev) => {
            if (media === displayMedia) return prev;
            const urls = [...new Set([media, displayMedia, ...prev].filter(Boolean))];
            // keep displayMedia first, then the newest panos; evict the oldest
            const rest = displayMedia
                ? [displayMedia, ...urls.filter((u) => u !== displayMedia)]
                : urls;
            return rest.slice(0, MAX_LIVE_PANOS);
        });
    }, [mediaType, media, displayMedia, livePanos]);

    // Reset the keep-alive pool when the level changes.
    useEffect(() => {
        setLivePanos([]);
        setDisplayMedia("");
    }, [props.now_level]);

    // Warm the browser cache with every 360 of the current level so a pano that
    // has never been opened decodes quickly (fetch is then a cache hit).
    useEffect(() => {
        const level = props.ifl_state.level[props.now_level];
        const panos = level ? level.panelum : [];
        panos.forEach((p) => {
            if (p && p.img) {
                const img = new Image();
                img.src = p.img;
            }
        });
    }, [props.now_level, props.ifl_state.level]);

    useEffect(() => {
        document.title = props.ifl_state.address;
    }, []);
    const mapStartfunc = () => setMapStart(false);

    const fitText = () => {
        const ruler = document.getElementById("ruler");
        if (!ruler) return;
        ruler.innerText = props.ifl_state.address;

        const fontSize =
            document.getElementsByClassName("addressBlock")[0].clientWidth / ruler.offsetWidth - 1;

        setMobileTextFontSize(Math.min(fontSize, window.innerHeight * 0.03));
    };

    const warningLevel = [];

    const isZeroMediaWarningVisible = !props.ifl_state.level.every(
        (level) => level.images?.length || level.panelum?.length
    );

    props.ifl_state.level.map((level) => {
        if (!(level.images?.length || level.panelum?.length))
            warningLevel.push({level: level.tabLabel, media: "images"});
    });

    const isPublishable = props.ifl_state.level.some(
        (level) => level.images?.length || level.panelum?.length
    );

    const [imgShow, setimgShow] = useState(false);

    const [landscapNewImg, setLandscapNewImg] = useState([]);

    useEffect(() => {
        if (props?.landscapImg?.level?.length) {
            const allImageUrls = [];
            for (let i = 0; i < props.landscapImg.level.length; i++) {
                const imagesUrls = props.landscapImg.level[i].images?.map((image) => image.library_image?.image);
                if (imagesUrls) allImageUrls.push(...imagesUrls);
            }
            setLandscapNewImg(allImageUrls);
        }
        if (transformWrapperRef.current) {
            recenterPlan();
        }
    }, [props?.landscapImg, props?.now_level]);

    return <ErrorBoundary><>
        {(props.ifl_state.published || router.query.preview === "true") &&
            props.ifl_state.template_name === "" ? (
                <>
                    <div className="start"
                         style={{
                             background: props.ifl_state.bgColor,
                             width: isPortrait ? `` : size[0],
                             height: size[1],
                             /* top: (isPortrait || isLandscape)
                                 ? `0`
                                 : `calc((100vh - ${size[1]}) / 2)`, */
                         }}>
                        <div ref={mobileHeaderRef} className={isPortrait || isLandscape ? "mobilePlayerHeader" : ""}>
                            {!splashScreen && !zoom && (isPortrait || isLandscape) ? (
                                <div className="tabs" style={{justifyContent: 'flex-start'}}>
                                    {(() => {
                                        const isFullList = visibleTabCount === null || visibleTabCount >= mobileTabs.length;
                                        const visibleTabs = isFullList ? mobileTabs : mobileTabs.slice(0, visibleTabCount);
                                        const hiddenTabs = isFullList ? [] : mobileTabs.slice(visibleTabCount);
                                        return (
                                            <div ref={tabsContainerRef}
                                                 style={{
                                                     display: 'flex',
                                                     overflow: 'hidden',
                                                     flex: '1 1 auto',
                                                     alignItems: 'stretch',
                                                 }}>
                                                {visibleTabs}
                                                {hiddenTabs.length > 0 && (
                                                    <div ref={moreTabRef}
                                                         className={"tab mobileMoreTab" + (hiddenTabs.some((t) => String(t.props.className).includes("active_tab")) ? " active_tab" : "")}
                                                         onClick={() => {
                                                             const next = !showMoreTabsDropdown;
                                                             if (next && moreTabRef.current) {
                                                                 const r = moreTabRef.current.getBoundingClientRect();
                                                                 setMoreMenuPos({top: r.bottom, left: r.left, width: r.width, right: r.right});
                                                             }
                                                             setShowMoreTabsDropdown(next);
                                                         }}
                                                         style={{position: 'relative'}}>
                                                        More ▾
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })()}
                                    <div ref={tabsMeasureRef}
                                         aria-hidden="true"
                                         style={{
                                             position: "absolute",
                                             visibility: "hidden",
                                             pointerEvents: "none",
                                             left: 0,
                                             top: 0,
                                             display: "flex",
                                         }}>
                                        {mobileTabs}
                                        <div className="tab mobileMoreTab">More ▾</div>
                                    </div>
                                </div>
                            ) : ("")}
                            {!splashScreen && !zoom && (isPortrait || isLandscape) && props.ifl_state.client_data ? (
                                <div className={showAgentModal ? "agentButton active" : "agentButton"}
                                     onClick={() => { trackTapAgent(); setShowAgentModal(true); }}>
                                    Agent
                                </div>
                            ) : ("")}
                            {showMoreTabsDropdown && moreMenuPos && createPortal(
                                <div className="moreTabsDropdown"
                                     style={{
                                         position: "fixed",
                                         top: moreMenuPos.top,
                                         left: "auto",
                                         right: window.innerWidth - moreMenuPos.right,
                                         minWidth: Math.max(150, moreMenuPos.width),
                                     }}>
                                    {(() => {
                                        const isFullList = visibleTabCount === null || visibleTabCount >= mobileTabs.length;
                                        const hiddenTabs = isFullList ? [] : mobileTabs.slice(visibleTabCount);
                                        return hiddenTabs.map((tab) => {
                                            const origOnClick = tab.props.onClick;
                                            return React.cloneElement(tab, {
                                                onClick: (e) => {
                                                    setShowMoreTabsDropdown(false);
                                                    if (origOnClick) origOnClick(e);
                                                }
                                            });
                                        });
                                    })()}
                                </div>,
                                mobileHeaderRef.current || document.body
                            )}

                            {zoom ? ("") : (
                                <div className="more"
                                     style={{display: splashScreen ? "none" : "block"}}>
                                    <svg onMouseDown={(e) => buttonMore(e)}
                                        // width="26"
                                        // height="18"
                                         width="5%"
                                         viewBox="0 0 26 18"
                                         fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M0.25 17.5H25.75V14.6667H0.25V17.5ZM0.25 10.4167H25.75V7.58333H0.25V10.4167ZM0.25 0.5V3.33333H25.75V0.5H0.25Z"
                                              fill="#8D8888"/>
                                    </svg>
                                    <div id="moreMenu"
                                         className="moreMenu"
                                         style={{display: activeButtonMore ? "flex" : "none"}}>
                                        {!isPortrait && !isLandscape ? (
                                            <>
                                                <button onClick={() => {
                                                    setShowShareMenu(prev => !prev);
                                                    setCopiedUrl(false);
                                                }}>
                                                    Share
                                                </button>
                                                {showShareMenu && (
                                                    <div className="shareMenuDesktop" onClick={(e) => e.stopPropagation()}>
                                                        <button className="shareMenuItem shareCopyLink"
                                                            onClick={() => {
                                                                navigator.clipboard.writeText(shareUrl);
                                                                setCopiedUrl(true);
                                                                setTimeout(() => setCopiedUrl(false), 2000);
                                                            }}>
                                                            {copiedUrl ? "Link copied" : "Copy link"}
                                                        </button>
                                                        <a className="shareMenuItem"
                                                            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
                                                            target="_blank" rel="noopener noreferrer" onClick={() => setShowShareMenu(false)}>Facebook</a>
                                                        <a className="shareMenuItem"
                                                            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent("Take a look around this property")}`}
                                                            target="_blank" rel="noopener noreferrer" onClick={() => setShowShareMenu(false)}>X</a>
                                                        <a className="shareMenuItem"
                                                            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`}
                                                            target="_blank" rel="noopener noreferrer" onClick={() => setShowShareMenu(false)}>LinkedIn</a>
                                                        <a className="shareMenuItem"
                                                            href={`https://wa.me/?text=${encodeURIComponent(shareUrl)}`}
                                                            target="_blank" rel="noopener noreferrer" onClick={() => setShowShareMenu(false)}>WhatsApp</a>
                                                        <a className="shareMenuItem"
                                                            href={`mailto:?subject=${encodeURIComponent("Take a look around this property")}&body=${encodeURIComponent(shareUrl)}`} onClick={() => setShowShareMenu(false)}>Email</a>
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <button onClick={async () => {
                                                trackTapShare();
                                                const url = window.location.href.replace("?preview=true", "");
                                                if (navigator.share) {
                                                    try {
                                                        await navigator.share({ title: document.title, url });
                                                    } catch {}
                                                } else {
                                                    await navigator.clipboard.writeText(url);
                                                    setCopiedUrl(true);
                                                }
                                            }}>
                                                {navigator.share ? "Share" : (copiedUrl ? "Link copied" : "Copy Link")}
                                            </button>
                                        )}

                                        {props.ifl_state.lat_long ? (
                                            <>
                                                <button
                                                    onClick={() => {
                                                        trackTapMaps();
                                                        if (mapStart) {
                                                            setMapStart(false);
                                                        } else {
                                                            setMapStart(true);
                                                            setActiveButtonMore(false);
                                                            setCopiedUrl(false);
                                                        }
                                                    }}
                                                >
                                                    Maps
                                                </button>
                                            </>
                                        ) : ("")}
                                        {props.ifl_state.textBlock ? (
                                            <button
                                                onClick={() => {
                                                    trackTapReadMore();
                                                    setShowInfoModal(true);
                                                    setActiveButtonMore(false);
                                                    setCopiedUrl(false);
                                                }}
                                            >
                                                Read More
                                            </button>
                                        ) : ("")}
                                        <button onClick={() => setActiveMarkers(!activeMarkers)}>
                                            {activeMarkers ? "Hide" : "Show"} markers
                                        </button>
                                        <button onClick={() => {
                                            trackTapFeedback();
                                            setShowFeedbackModal(true);
                                            setActiveButtonMore(false);
                                            setCopiedUrl(false);
                                        }}>
                                            Feedback
                                        </button>
                                        {brandingQuery === "hb=1" ? ("")
                                            : brandingQuery === "hbo=1"
                                                ? ("")
                                                : props.ifl_state.brand_logo ? (
                                            <button onClick={() => {
                                                trackTapCreatedBy();
                                                setShowBrandModal(true);
                                                setActiveButtonMore(false);
                                                setCopiedUrl(false);
                                            }}>
                                                Created by...
                                            </button>
                                        ) : ("")}
                                    </div>
                                </div>
                            )}
                        </div>
                        <Popup
                            className="contentTextInfo"
                            open={showInfoModal}
                            closeOnDocumentClick
                            onClose={() => {
                                setShowInfoModal(false);
                            }}
                        >
                            <div className="contentTextInfo">
                                <button
                                    className="closePopup"
                                    onClick={() => setShowInfoModal(false)}
                                    aria-label="Close"
                                >
                                    &times;
                                </button>
                                {parse(contentInfoModal)}
                            </div>
                        </Popup>

                        {!isPortrait && !isLandscape && (
                            <div
                                className={
                                    "feedbackTab" +
                                    (tabsStyle.right !== undefined ||
                                    ((tabsStyle.transform || "").includes("rotate(90") &&
                                    !(tabsStyle.transform || "").includes("rotate(-90"))
                                        ? " feedbackTab-top"
                                        : "")
                                }
                                onClick={() => setShowFeedbackModal(true)}
                            >
                                Feedback
                            </div>
                        )}

                        <Popup
                            className="feedbackModal"
                            open={showFeedbackModal}
                            closeOnDocumentClick
                            onClose={() => {
                                setShowFeedbackModal(false);
                                if (feedbackSubmitted) {
                                    setFeedbackUseful(null);
                                    setFeedbackRole('');
                                    setFeedbackRating(0);
                                    setFeedbackName('');
                                    setFeedbackEmail('');
                                    setFeedbackMessage('');
                                    setFeedbackSubmitted(false);
                                }
                            }}
                        >
                            <div className="feedbackForm">
                                <button
                                    className="closePopup"
                                    onClick={() => setShowFeedbackModal(false)}
                                    aria-label="Close"
                                >
                                    &times;
                                </button>
                                {feedbackSubmitted ? (
                                    <div className="feedbackThankYou">
                                        <h3>Thank you so much!</h3>
                                        <p>Your feedback is appreciated. We will use it to continually improve this&nbsp;product.</p>
                                    </div>
                                ) : (
                                    <>
                                        <div className="feedbackHeader">
                                            <h3>We'd love your feedback!</h3>
                                            <p className="feedbackSub">Help us improve your experience</p>
                                        </div>

                                        <div className="feedbackQuestion">
                                            <p className="feedbackQ">Are you finding this Virtual Tour useful?</p>
                                        <div className="feedbackYesNo">
                                            <button
                                                className={feedbackUseful === true ? 'active' : ''}
                                                onClick={() => setFeedbackUseful(true)}
                                            >Yes</button>
                                            <button
                                                className={feedbackUseful === null ? 'active' : ''}
                                                onClick={() => setFeedbackUseful(null)}
                                            >Maybe</button>
                                            <button
                                                className={feedbackUseful === false ? 'active' : ''}
                                                onClick={() => setFeedbackUseful(false)}
                                            >No</button>
                                        </div>
                                        </div>

                                        <div className="feedbackQuestion">
                                            <p className="feedbackQ">Are you a…</p>
                                            <div className="feedbackRoleGroup">
                                                {['Buyer', 'Seller', 'Real estate professional'].map(r => (
                                                    <button
                                                        key={r}
                                                        className={feedbackRole === r ? 'active' : ''}
                                                        onClick={() => setFeedbackRole(r)}
                                                    >{r}</button>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="feedbackQuestion">
                                            <p className="feedbackQ">Overall, how many stars would you rate this product?</p>
                                            <div className="feedbackStars">
                                                {[1, 2, 3, 4, 5].map(s => (
                                                    <span
                                                        key={s}
                                                        className={'star' + (s <= feedbackRating ? ' filled' : '')}
                                                        onClick={() => setFeedbackRating(s)}
                                                    >★</span>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="feedbackQuestion">
                                            <p className="feedbackQ">Tell us about your experience</p>
                                            <textarea
                                                placeholder="What did you like or what could we improve?…"
                                                value={feedbackMessage}
                                                onChange={(e) => setFeedbackMessage(e.target.value)}
                                                rows={3}
                                                maxLength={2000}
                                            />
                                        </div>

                                        <div className="feedbackQuestion">
                                            <p className="feedbackQ">If you'd like us to get back to you, leave your details below</p>
                                            <input
                                                type="text"
                                                placeholder="Your name"
                                                value={feedbackName}
                                                onChange={(e) => setFeedbackName(e.target.value)}
                                                maxLength={100}
                                            />
                                            <input
                                                type="email"
                                                placeholder="Your email address"
                                                value={feedbackEmail}
                                                onChange={(e) => setFeedbackEmail(e.target.value)}
                                                maxLength={200}
                                            />
                                        </div>

                                        <button
                                            className="feedbackSubmit"
                                            disabled={feedbackSubmitting}
                                            onClick={async () => {
                                                setFeedbackSubmitting(true);
                                                try {
                                                    await submitFeedback({
                                                        plan_id: props.ifl_state.id,
                                                        useful: feedbackUseful,
                                                        role: feedbackRole,
                                                        rating: feedbackRating || null,
                                                        name: feedbackName,
                                                        contact_email: feedbackEmail,
                                                        message: feedbackMessage,
                                                    });
                                                    setFeedbackSubmitted(true);
                                                } catch (e) {
                                                    console.error('Feedback submit error', e);
                                                }
                                                setFeedbackSubmitting(false);
                                            }}
                                        >
                                            {feedbackSubmitting ? 'Sending…' : 'Send feedback'}
                                        </button>
                                    </>
                                )}
                            </div>
                        </Popup>

                        {brandingQuery === "hb=1" ? ("")
                            : brandingQuery === "hco=1"
                                ? ("")
                                : props.ifl_state.client_data === ""
                                    ? ("")
                                    : !zoom && !isPortrait && !isLandscape ? (
                                        <div className="client_wrap_main" style={clientWrapStyle}>
                                            <Client
                                                clientData={JSON.parse(props.ifl_state.client_data)}
                                                clientPosition={JSON.parse(props.ifl_state.client_position)}
                                                viewHeight={viewSize[1]}
                                            />
                                        </div>) : ("")}

                        {!splashScreen && !zoom && !isPortrait && !isLandscape ? (
                            <div className="tabs" style={{
                                ...tabsStyle,
                                position: (tabsStyle.transform || "").includes("rotate") ? "absolute" : undefined,
                            }}>
                                {!isPortrait && !isLandscape ? (
                                    <>
                                        {tabs}
                                        {mediaTabs}
                                    </>) : (mobileTabs)}
                            </div>
                        ) : ("")}

                        {mediaScreen ? (
                            <Media
                                index={mediaIndex}
                                mediaData={props.ifl_state.media[mediaIndex]}
                                address={props.ifl_state.address}
                            />) : ("")}

                        {props.ifl_state.lat_long === "" ? ("") : (<MapWrapPopup
                            latLong={props.ifl_state.lat_long}
                            action={mapStart}
                            mapStart={() => mapStartfunc()}
                        />)}

                        <div className={"layout_image"}>
                            <div className="images" style={imageWrapStyle}>
                                {startLoading && mediaType === "panorama" &&
                                props.ifl_state.level[props.now_level].panelum.length > 0 ? (
                                    <>
                                        {livePanos.map((url) => {
                                            const isDisplay = url === displayMedia;
                                            return (
                                                <div key={url}
                                                     style={isDisplay ? undefined : {
                                                         position: "absolute",
                                                         top: 0,
                                                         left: 0,
                                                         width: "100%",
                                                         height: 0,
                                                         overflow: "visible",
                                                         opacity: 0,
                                                         pointerEvents: "none",
                                                         zIndex: 0,
                                                     }}>
                                                    <Pannellum imgShow={imgShow}
                                                               width="100%"
                                                               image={url}
                                                               pitch={pitch}
                                                               height={
                                                                   isPortrait
                                                                       ? window.innerWidth * 0.64
                                                                       : isLandscape
                                                                           ? window.innerWidth * 0.3333
                                                                           : (viewSize[1] * parseFloat(imageWrapStyle.height)) / 100
                                                               }
                                                               yaw={yaw}
                                                               hfov={hfov}
                                                               autoLoad
                                                               event="load"
                                                               handleEvent={() => {
                                                                   setFinishLoadImage(true);
                                                               }}
                                                               onImageLoaded={(loadedUrl) => {
                                                                   if (loadedUrl === media) setDisplayMedia(loadedUrl);
                                                               }}
openImage={openImage}
autoRotate={isDisplay ? -2 : 0}
                                                          // setZoom={setZoom}
                                                    ></Pannellum>
                                                </div>
                                            );
                                        })}
                                    </>
                                ) : ("")}
                                {startLoading && mediaType === "image" && sliderData.length > 0 ? (
                                    <>
                                        {isLandscape && <LandscapSlider data={landscapNewImg}
                                                                      startIndex={indexMarker == null || indexMarker < 0
                                                                          ? 0
                                                                          : Math.max(0, sliderData.findIndex((el) => el.l_index === props.now_level && el.m_index === indexMarker))}/>}
                                        <div className={isLandscape ? "d-none" : "d-block"}>
                                            <IfloorplanSlider
                                                src={sliderData}
                                                index={indexMarker}
                                                setIndexMarker={setIndexMarker}
                                                setLevelIndex={(lvl) => { stripSwipeRef.current = true; trackSwipeImages(); props.initLevel(lvl); }}
                                                setZoom={setZoom}
                                                zoom={zoom}
                                                setSlidePlayStatement={setSlidePlay}
                                                slidePlayStatement={slidePlay}
                                                nowLevel={props.now_level}
                                                count={
                                                    props.ifl_state.level[props.now_level].images.length
                                                }
                                                isPortrait={isPortrait}
                                                isLandscape={isLandscape}
                                                setHeightImage={setHeigthImage}
                                                kenburns={props.ifl_state.kenburns}
                                                kenBurnsZoom={kenBurnsZoom}
                                                setKenBurnsZoom={setKenBurnsZoom}
                                                setFinishLoadImage={setFinishLoadImage}
                                                splashScreen={splashScreen}
                                                restartAfterSplashScreen={restartAfterSplashScreen}
                                                setRestartAfterSplashScreen={
                                                    setRestartAfterSplashScreen
                                                }
                                                width={(props.ifl_state.img_width * viewSize[0]) / 100}
                                                height={
                                                    (props.ifl_state.img_height * viewSize[1]) / 100
                                                }
                                                setIsMarkerClicked={setIsMarkerClicked}
                                            />
                                        </div>
                                    </>) : ("")}

                                {mediaType === "video" ? (
                                    <iframe
                                        height={heightImage + "px"}
                                        id="ytplayer"
                                        type="text/html"
                                        src={"https://www.youtube.com/embed/" + media + "?autoplay=1&origin="}
                                        frameBorder="0"
                                    />) : ("")}
                            </div>
                            {showHint && !splashScreen && !isLandscape && (
                                <div className={"hint-modal"}>
                                    <img className="hint-img" src="/static/public/img/hint-pinch.png"/>
                                    <img className="hint-img" src="/static/public/img/hint-tap.png"/>
                                    <span className="hint-close">Explore</span>
                                </div>
                            )}
                            <div
                                onClick={(e) => {
                                    setimgShow(true);
                                    if (planRef.current) trackTapPlan(e.clientX, e.clientY, planRef.current);
                                }}
                                className="plan my_plan"
                                id="planClick"
                                style={planWrapStyle}
                            >
                                {startLoading ? (
                                    window.innerWidth >= 991 ? (
                                        <div className="position-relative">
                                            {activeMarkers ? markers : ""}
                                            <img
                                                src={allPlan[props.now_level]}
                                                alt=""
                                                id="plan"
                                                onLoad={(image) => {
                                                    setFinishLoadPlan(true);
                                                }}
                                                ref={planRef}
                                            />
                                        </div>
                                    ) : (
                                        <>
                                        <TransformWrapper ref={transformWrapperRef} initialScale={isTablet() ? 0.64 : 0.8} minScale={0.2} maxScale={15}
                                                          limitToBounds={false}
                                                          autoAlignment={{ sizeX: 0, sizeY: 0 }}
                                                          panning={{ velocityDisabled: true }}>
                                            <DragAndDrop imgShow={imgShow}>
                                                <div className="position-relative">
                                                    {activeMarkers ? markers : ""}
                                                    <img
                                                        src={allPlan[props.now_level]}
                                                        alt=""
                                                        className="my_plan_img"
                                                        id="plan"
                                                        onLoad={(image) => {
                                                            setFinishLoadPlan(true);
                                                        }}
                                                        ref={planRef}
                                                    />
                                                </div>
                                            </DragAndDrop>
                                        </TransformWrapper>
                                        <button className="reset_btn"
                                                onClick={() => {
                                                    trackTapReset();
                                                    recenterPlan();
                                                }}>
                                            <svg fill="#ffffff"
                                                 viewBox="0 0 1920 1920"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <g id="SVGRepo_bgCarrier" strokeWidth={0}/>
                                                <g id="SVGRepo_tracerCarrier"
                                                   strokeLinecap="round"
                                                   strokeLinejoin="round"/>
                                                <g id="SVGRepo_iconCarrier">
                                                    {" "}
                                                    <path
                                                        d="M960 0v213.333c411.627 0 746.667 334.934 746.667 746.667S1371.627 1706.667 960 1706.667 213.333 1371.733 213.333 960c0-197.013 78.4-382.507 213.334-520.747v254.08H640V106.667H53.333V320h191.04C88.64 494.08 0 720.96 0 960c0 529.28 430.613 960 960 960s960-430.72 960-960S1489.387 0 960 0"
                                                        fillRule="evenodd"/>
                                                    {" "}
                                                </g>
                                            </svg>
                                        </button>
                                        </>
                                    )
                                ) : null}
                            </div>
                        </div>

                        {props.ifl_state.address && (
                            <div className="addressBlock"
                                 style={{
                                     ...textStyle,
                                     fontSize:
                                         isPortrait || isLandscape
                                             ? mobileTextFontSize
                                             : textStyle.fontSize,
                                     padding:
                                         isPortrait || isLandscape
                                             ? (window.innerHeight * 0.03 - mobileTextFontSize) / 2 + "px" : 0,
                                     display: "block",
                                 }}>
                                {props.ifl_state.address}
                            </div>
                        )}

                        {brandingQuery === "hb=1"
                            ? ""
                            : brandingQuery === "hbo=1"
                                ? ""
                                : !isPortrait &&
                                !isLandscape && (
                                    <div
                                        className="brandWrap"
                                        style={{
                                            position: "absolute",
                                            left: props.ifl_state.brand_pos_x + "%",
                                            top: props.ifl_state.brand_pos_y + "%",
                                            width: props.ifl_state.brand_width + "%",
                                            opacity: props.ifl_state.brand_transparency,
                                        }}
                                    >
                                        <a href={props.ifl_state.brand_url} target="_blank">
                                            <img
                                                style={{width: "100%"}}
                                                src={props.ifl_state.brand_logo}
                                                alt=""
                                            />
                                        </a>
                                    </div>
                                )}
                    </div>
                    {splashScreen ? (
                        <>
                            <SplashScreen
                                data={props.ifl_state}
                                showHint={showHint}
                                setFinishLoadSplashScreen={setFinishLoadSplashScreen}
                            />
                        </>
                    ) : ("")}
                    {(isPortrait || isLandscape) && <div className="space"/>}
                    <span
                        id="ruler"
                        style={{
                            visibility: "hidden",
                            ...textStyle,
                            fontSize: "1px",
                        }}
                    ></span>
                </>
            ) : (
                <>
                    <UnpublishedNotice
                        WhiteLabelInfo={props.ifl_state.domain_uri}
                        author={props.ifl_state.author}
                    />
                </>
            )}

            <div
                className="PublishModal"
                style={{display: showPublishModal ? "flex" : "none"}}
            >
                {isZeroMediaWarningVisible ? (
                    <span className="levelWarning">
            The Level *{warningLevel[0].level}* has no {warningLevel[0].media}
          </span>
                ) : ("")}
                <div className="PublishModal-header">
                    Ready to{" "}
                    {props.type_action === "edit" && props.ifl_state.first_published_datetime ? "update" : "Publish"}{" "}
                    your iFloorPlan?
                </div>
                {props.type_action === "edit" && props.ifl_state.first_published_datetime ? (
                    <div className="UpdateModal-body">
                        <a
                            className="UpdateModal-btn"
                            onClick={async (event) => {
                                if (!isPublishable) event.preventDefault();
                                else {
                                    Publish();
                                    //window.location.assign('/user/new');
                                    setShowPublishModal(false);
                                    setshowPublishedModal(true);
                                    setShowShareIcons(false);
                                    setCopiedLink(false);
                                }
                            }}
                        >
                            <p
                                className={isPublishable ? "UpdateModal-label" : "UpdateModal-label not"
                                }
                            >
                                Update and Republish
                            </p>
                        </a>
                    </div>
                ) : (
                    <div className="PublishModal-body">
                        <a
                            className="PublishModal-btn"
                            onClick={async (event) => {
                                if (!isPublishable) event.preventDefault();
                                else {
                                    Publish();
                                    //window.location.assign('/user/new');
                                    setShowPublishModal(false);
                                    setshowPublishedModal(true);
                                    setShowShareIcons(false);
                                    setCopiedLink(false);
                                }
                            }}
                        >
                            <p
                                className={isPublishable ? "PublishModal-label" : "PublishModal-label not"}
                            >
                                Deduct 1 credit and Publish
                            </p>
                        </a>
                    </div>
                )}
                <div
                    className={props.type_action === "edit" && props.ifl_state.first_published_datetime ? "updateModal-footer" : "PublishModal-footer"}
                >
          <span className="PublishModal-close">
            <h5>Cancel and continue editing</h5>
          </span>
                </div>
            </div>
            <div
                className="UpdatedModal"
                style={{display: showPublishedModal ? "flex" : "none"}}
            >
                <h3 className="UpdatedModal-label">
                    {props.type_action === "edit" && props.ifloorplanNowState.first_published_datetime ? "Republished" : "Published"}
                </h3>
                <div>You can now close this window</div>
                <div className="UpdatedModal-url">{shareUrl}</div>
                <div className="UpdatedModal-buttons">
                    <div
                        className="UpdatedModal-copylink"
                        onClick={() => {
                            navigator.clipboard.writeText(shareUrl);
                            setCopiedLink(true);
                        }}
                    >
                        {copiedLink ? "Link copied" : "Copy link"}
                    </div>
                    <div
                        className="UpdatedModal-share"
                        onClick={() => {
                            setShowShareIcons(!showShareIcons);
                        }}
                    >
                        Share
                    </div>
                </div>
                <div className="UpdatedModal-shareIcons">
                    {showShareIcons ? (
                        <InlineShareButtons
                            config={{
                                alignment: "center", // alignment of buttons (left, center, right)
                                color: "social", // set the color of buttons (social, white)
                                enabled: true, // show/hide buttons (true, false)
                                font_size: 16, // font size for the buttons
                                labels: "null", // button labels (cta, counts, null)
                                language: "en", // which language to use (see LANGUAGES)
                                networks: [
                                    // which networks to include (see SHARING NETWORKS)
                                    "facebook",
                                    "twitter",
                                    "linkedin",
                                    "messenger",
                                    "email",
                                ],
                                padding: 12, // padding within buttons (INTEGER)
                                radius: 4, // the corner radius on each button (INTEGER)
                                show_total: true,
                                size: 30, // the size of each button (INTEGER)

                                // OPTIONAL PARAMETERS
                                url: shareUrl,
                                image: window.location.href.replace(router.asPath, props.ifl_state.splash_screen), // (defaults to og:image or twitter:image)
                                description: "This is my new iFloorPlan", // (defaults to og:description or twitter:description)
                                title: "Take a look around this property", // (defaults to og:title or twitter:title)
                                message: shareUrl + "\nClick the icons on the floor plan to see the image taken from that spot. \n", // (only for email sharing)
                                subject: "Take a look around this property", // (only for email sharing)
                            }}
                        />
                    ) : ("")}
                </div>
            </div>
            {showAgentModal && brandingQuery !== "hb=1" && brandingQuery !== "hco=1" && createPortal(
                <div className="playerModal-overlay" onClick={() => setShowAgentModal(false)}>
                    <div className="playerModal-content" onClick={(e) => e.stopPropagation()}>
                        <span className="playerModal-close" onClick={() => setShowAgentModal(false)}>×</span>
                        {(() => {
                            try {
                                const clientData = JSON.parse(props.ifl_state.client_data || '{}');
                                const clientPosition = JSON.parse(props.ifl_state.client_position || '{}');
                                return (
                                    <div className="playerModal-agent">
                                        {clientPosition.logo && (
                                            <a href={clientData.url_click} target="_blank" rel="noreferrer">
                                                <img className="playerModal-agent-logo" src={clientPosition.logo} alt=""/>
                                            </a>
                                        )}
                                        {clientData.contact_name && <p className="playerModal-agent-name">{clientData.contact_name}</p>}
                                        {clientData.contact_phone && <p className="playerModal-agent-phone">{clientData.contact_phone}</p>}
                                        {clientData.contact_email && (
                                            <a className="playerModal-agent-email" href={"mailto:" + clientData.contact_email}>{clientData.contact_email}</a>
                                        )}
                                    </div>
                                );
                            } catch (e) {
                                return null;
                            }
                        })()}
                    </div>
                </div>,
                document.body
            )}
            {showBrandModal && brandingQuery !== "hb=1" && brandingQuery !== "hbo=1" && createPortal(
                <div className="playerModal-overlay" onClick={() => setShowBrandModal(false)}>
                    <div className="playerModal-content" onClick={(e) => e.stopPropagation()}>
                        <span className="playerModal-close" onClick={() => setShowBrandModal(false)}>×</span>
                        <div className="playerModal-brand">
                            <p className="playerModal-brand-title">Created by</p>
                            {props.ifl_state.brand_url ? (
                                <a href={props.ifl_state.brand_url} target="_blank" rel="noreferrer">
                                    <img className="playerModal-brand-logo" src={props.ifl_state.brand_logo} alt=""/>
                                </a>
                            ) : (
                                <img className="playerModal-brand-logo" src={props.ifl_state.brand_logo} alt=""/>
                            )}
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </>
        </ErrorBoundary>
    ;
};

const putState = (state) => {
    return {
        ifl_state: state.ifl_state,
        current_user: state.current_user,
        now_level: state.now_level,
        now_image: state.now_image,
        prev_step: state.prev_step,
        now_marker: state.now_marker,
        marker_activity: state.marker_activity,
        place_holder_layout: state.place_holder_layout,
        screen_size: state.screen_size,
    };
};

const putActions = (dispatch) => {
    return {
        changeStep: (step) => dispatch(changeStep(step)),
        initLevel: (level) => dispatch(initLevel(level)),
        setMarkerActivity: (bool) => dispatch(setMarkerActivity(bool)),
        initPlaceHolderLayout: (layout) => dispatch(initPlaceHolderLayout(layout)),
        initScreenSize: (size) => dispatch(initScreenSize(size)),
    };
};

export default connect(putState, putActions)(Start);

('{"id":243,"logo":"https://storage.googleapis.com/ifloorplan3-c1d28.appspot.com/accounts/21/clients/client_445/me.jpg1674134676.0623705","width":10,"position_logo_x":4.390495729351967,"position_logo_y":1.033057900092601,"position_name_x":8,"position_name_y":70,"position_phone_x":18.724172963412798,"position_phone_y":71.28099510638947,"position_brand_x":8,"position_brand_y":14,"position_contact_x":35.123965834815735,"position_contact_y":71.28099510638947,"textColor":"null","fontWeight":"normal","fontStyle":"normal","fontSize":2,"fontFamily":"Roboto, sans-serif","emailButton":false,"author":28,"client":445}');